import HorizontalForm from '../landing-form/horizontal-form'
import { usePortalTranslate } from '@/hooks'
import { useContext } from 'react'
import { EditedCopiesContext } from '@/ui/components/portal-preview/preview-contexts'
import {
  usePortalLogoHeight,
  usePortalLogoUrl
} from '@/ui/components/portal-preview/use-portal-branding'

// This layout draws the logo larger than the other two, and so does the portal.
const LOGO_FALLBACK = { mobile: '2rem', desktop: '4rem' }

export const SimplifiedLanding: React.FC = () => {
  const editedCopies = useContext(EditedCopiesContext)
  const { translate } = usePortalTranslate(editedCopies)

  // Via the hook rather than the stored settings, so an editor's unsaved image previews.
  const logoUrl = usePortalLogoUrl()
  const logoHeight = usePortalLogoHeight(LOGO_FALLBACK)

  return (
    <div className="relative size-full">
      <div className="flex h-full flex-col items-center justify-evenly">
        <div className="flex w-full flex-col items-center text-center">
          <b>
            <span
              className="mt-4 px-4 md:text-lg"
              dangerouslySetInnerHTML={{
                __html: translate('landing_title_layout_simplified')
              }}
            />
          </b>
          <span
            className="mt-2 p-4 md:text-lg"
            dangerouslySetInnerHTML={{
              __html: translate('landing_subtitle')
            }}
          />
          <HorizontalForm />
        </div>

        <div className="mt-8" style={{ height: logoHeight }}>
          <img className="h-full max-w-full object-contain" src={logoUrl} />
        </div>
      </div>
    </div>
  )
}

export default SimplifiedLanding
